import { GET_REFERENCE_BIKE_REQUEST, GET_REFERENCE_BIKE_REQUEST_FAILURE, GET_REFERENCE_BIKE_REQUEST_SUCCESS } from '../constants/get_reference_bike.constants';


const initialState = {
    loading: false,
    data: {},
    error: null,
};

export const Reference_bike = (state = initialState, action) => {
    switch (action.type) {
    case GET_REFERENCE_BIKE_REQUEST:
        return {
            ...state,
            loading: true,
            data: {},
        };
    case GET_REFERENCE_BIKE_REQUEST_SUCCESS:
        return {
            ...state,
            data: action.data,
            loading: false,
        };
    case GET_REFERENCE_BIKE_REQUEST_FAILURE:
        return {
            ...state,
            error: action.error,
            loading: false,
            data: {},
        };
    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/reducers/reference_bike.reducer.js